import { TYPES, container } from '@/libs/di/inversify.config'
import type { AccountUsecase } from '@/apis/usecases'
import type { ActionTree } from 'vuex'
import type { State } from './state'

import { trackSession, unsetTrackingPlanner } from '@/newrelic'

export const actions: ActionTree<State, State> = {
  async login(
    { commit },
    payload: { email: string; password: string }
  ): Promise<void> {
    const accountUsecase = container.get<AccountUsecase>(TYPES.AccountUsecase)
    const token = await accountUsecase.requestLogin(payload)
    commit('updateAPIToken', token)
  },

  async logout({ commit, getters }): Promise<void> {
    if (getters.apiToken == null) {
      return
    }
    const accountUsecase = container.get<AccountUsecase>(TYPES.AccountUsecase)
    await accountUsecase.postLogout()
    unsetTrackingPlanner()
    commit('clearAPIToken')
  },

  async updateSession(): Promise<void> {
    const accountUsecase = container.get<AccountUsecase>(TYPES.AccountUsecase)
    const { longSessionId } = await accountUsecase.updateSession()
    trackSession(longSessionId)
  },
}
